module.exports = __webpack_public_path__ + "static/gp-f777d74851ff897e69e6f958ba7fe184.png";